export default __webpack_public_path__ + "static/media/icw-Competitive.5dc91315.jpg";